import { useState, useCallback } from 'react';

const useRerender = () => {
  const [, setState] = useState(0);
  return useCallback(() => setState((state) => state + 1), []);
};

export const useFacade = (selectedCountries = []) => {
  const [stateSet] = useState(() => new Set(selectedCountries.map((country) => country.cca2)));
  const state = [...stateSet.values()];
  const rerender = useRerender();

  const isActive = useCallback(
    (cca2) => {
      return stateSet.has(cca2);
    },
    [stateSet],
  );

  const toggle = useCallback(
    (...stateItems) => {
      stateItems.forEach((stateItem) =>
        isActive(stateItem) ? stateSet.delete(stateItem) : stateSet.add(stateItem),
      );
      rerender();
    },
    [isActive],
  );
  const toggleOn = useCallback(
    (...stateItems) => toggle(...stateItems.filter((stateItem) => !stateSet.has(stateItem))),
    [toggle],
  );
  const toggleOff = useCallback(
    (...stateItems) => toggle(...stateItems.filter((stateItem) => stateSet.has(stateItem))),
    [toggle],
  );

  const toggleOffAll = useCallback(() => {
    stateSet.clear();
    rerender();
  }, [stateSet, rerender]);

  return { state, isActive, toggle, toggleOffAll, toggleOn, toggleOff };
};
